// extracted by mini-css-extract-plugin
export default {"MainHeader":"MainHeader_MainHeader__ssuSA","Navbar":"MainHeader_Navbar__7KmmZ","NavLink":"MainHeader_NavLink__utOP8"};